if (typeof window !== 'undefined' && window.history && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

import { createApp } from 'vue';
import App from './App.vue';
import { router } from './router';
import { createShowcaseStore } from '@/store/showcase';
import { provideShowcase } from '@/store/use-showcase';

import './styles/fonts.css';
import './styles/tokens.css';
import './styles/rich-text.css';
import './styles/pdf-viewer.css';

/**
 * 前台应用入口（F01 + F02）。
 *
 * 顺序约束：
 *   1. `fonts.css` 必须先声明 F20 模板标题字体，随后 `tokens.css` 注入
 *      CSS 变量，随后 `rich-text.css` / `pdf-viewer.css` 消费 token 给
 *      正文与 PDF.js viewer 补模板视觉（F15/F19）。
 *   2. vue-router 在 mount 之前 use()，避免首屏组件读到 undefined route。
 *   3. F02 Showcase Store 在 mount 之前通过 `app.provide` 注入。
 *      **不在此调 `bootstrap()`**——bootstrap 触发留 F03 HomePage
 *      `onMounted`，避免占位页无后端时启动报错（store 停在 idle，
 *      占位页正常渲染）。
 */
const app = createApp(App);
app.use(router);
provideShowcase(app, createShowcaseStore());
app.mount('#app');
